import React from 'react';
import appConfig from '../config';
import { Link as Lnk } from 'react-router-dom';
import styled from 'styled-components';

const StyledA = styled.a`
  text-decoration: none;
`;

const StyledLink = styled(Lnk)`
  text-decoration: none;
`;

const Link = (props: any) => {
  if (appConfig.SSR) {
    const handleClick = (e: any) => {
      e.preventDefault();
      props.nextRouter.push(`${appConfig.baseUrl}${props.to}`);
    };
    return <StyledA onClick={e => handleClick(e)}>{props.children}</StyledA>;
  } else {
    return <StyledLink to={`${props.to}`}>{props.children}</StyledLink>;
  }
};

export default Link;
